/**
 * P2-2 — matriz ruta → perfil → módulo requerido (alineada con App.js).
 * access: Public | Authenticated | Administrativo | Alumno
 */

function admin(path, component, module, exact = false) {
  return { path, component, exact, access: 'Administrativo', modules: [module], testCoverage: 'routeGuardService.test.js' };
}

function alumno(path, component, exact = false) {
  return { path, component, exact, access: 'Alumno', modules: ['InscribirCursada'], testCoverage: 'routeGuardService.test.js' };
}

export const routeSecurityRegistry = [
  { path: '/', component: 'Home', exact: true, access: 'Public', modules: [], testCoverage: 'layoutAuthGate.test.js' },
  { path: '/counter', component: 'Counter', access: 'Authenticated', modules: [], testCoverage: 'routeGuardService.test.js' },
  { path: '/cambiar-contrasena', component: 'CambiarContrasena', access: 'Authenticated', modules: [], testCoverage: 'routeGuardService.test.js' },
  admin('/md-alumnos', 'MDAlumnos', 'WWAlumnos'),
  admin('/md-carreras', 'MDCarreras', 'WWCarreras'),
  admin('/md-axc', 'MDAlumnoxCarrera', 'WWAlumnosxCarrera'),
  admin('/md-mxc', 'MDMateriaCarrera', 'WWMaterias'),
  admin('/md-anios', 'MDAnioAcademicos', 'WWAnioAcademico'),
  admin('/md-pex', 'MDPeriodoExamen', 'WWPeriodoExamen'),
  admin('/md-pcr', 'MDPeriodoCursada', 'WWPeriodoCursada'),
  admin('/md-cur', 'MDCursadas', 'WWCursada'),
  admin('/md-ic', 'MDInscripcionCursada', 'WWInscripcionCursada'),
  admin('/md-ie', 'MDInscripcionExamen', 'WWInscripcionExamen'),
  admin('/md-mex', 'MDMesaExamen', 'WWMesaExamen'),
  admin('/md-acur', 'MDActasCursadas', 'WWActasCursado'),
  admin('/md-aex', 'MDActaExamen', 'WWActasExamen'),
  admin('/md-hic', 'MDHistoriaAcademicaCursada', 'HistoriaAcademicaCursada'),
  admin('/md-hex', 'MDHistoriaAcademicaExamen', 'HistoriaAcademicaExamen'),
  admin('/md-crendir', 'MDCorrelatividadRendir', 'WWCorrelatividadesRendir'),
  admin('/md-ccursar', 'MDCorrelatividadCursar', 'WWCorrelatividadesCursada'),
  admin('/add-alumno', 'AddAlumnos', 'WWAlumnos'),
  admin('/add-carrera', 'AddCarrera', 'WWCarreras'),
  admin('/add-axc', 'AddAlumnoCarrera', 'WWAlumnosxCarrera'),
  admin('/add-mxc', 'AddMateria', 'WWMaterias'),
  admin('/add-anio', 'AddAnioAcademico', 'WWAnioAcademico'),
  admin('/add-pex', 'AddPeriodoExamen', 'WWPeriodoExamen'),
  admin('/add-pcr', 'AddPeriodoCursada', 'WWPeriodoCursada'),
  admin('/add-cur', 'AddCursada', 'WWCursada'),
  admin('/add-ic', 'AddInscripcionCursada', 'WWInscripcionCursada'),
  admin('/add-ie', 'AddInscripcionExamen', 'WWInscripcionExamen'),
  admin('/add-mex', 'AddMesaExamen', 'WWMesaExamen'),
  admin('/add-crendir', 'AddCorrelatividadRendir', 'WWCorrelatividadesRendir'),
  admin('/add-ccursar', 'AddCorrelatividadCursar', 'WWCorrelatividadesCursada'),
  admin('/update-alumno/:id/:details', 'UpdateAlumno', 'WWAlumnos'),
  admin('/update-carrera/:id/:details', 'UpdateCarrera', 'WWCarreras'),
  admin('/update-axc/:id/:details', 'UpdateAlumnoCarrera', 'WWAlumnosxCarrera'),
  admin('/update-mxc/:id/:details', 'UpdateMateria', 'WWMaterias'),
  admin('/update-anio/:id/:details', 'UpdateAnioAcademico', 'WWAnioAcademico'),
  admin('/update-pex/:id/:details', 'UpdatePeriodoExamen', 'WWPeriodoExamen'),
  admin('/update-pcr/:id/:details', 'UpdatePeriodoCursada', 'WWPeriodoCursada'),
  admin('/update-cur/:id/:details', 'UpdateCursada', 'WWCursada'),
  admin('/update-ic/:id/:details', 'UpdateInscripcionCursada', 'WWInscripcionCursada'),
  admin('/update-mex/:id/:details', 'UpdateMesaExamen', 'WWMesaExamen'),
  admin('/update-crendir/:id/:details', 'UpdateCorrelativaRendir', 'WWCorrelatividadesRendir'),
  admin('/update-ccursar/:id/:details', 'UpdateCorrelativaCursar', 'WWCorrelatividadesCursada'),
  admin('/update-ie/:id/:details', 'UpdateInscripcionExamen', 'WWInscripcionExamen'),
  admin('/update-hic/:id/:details', 'UpdateHistoriaAcademicaCursada', 'HistoriaAcademicaCursada'),
  admin('/update-hex/:id/:details', 'UpdateHistoriaAcademicaExamen', 'HistoriaAcademicaExamen'),
  admin('/update-eae/:id', 'UpdateEncabezado', 'WWActasExamen'),
  admin('/gen-cur', 'GenerarCursadas', 'WWCursada'),
  admin('/vic', 'ValidarInscripcionCursadas', 'WWInscripcionCursada'),
  admin('/cme', 'CargarMesas', 'WWMesaExamen'),
  admin('/iap', 'InscribirAlumnosPrimero', 'WWAlumnos'),
  admin('/pago-inscripcion', 'MarcarPagoInscripcion', 'WWAlumnos'),
  admin('/axc-inscribir', 'InscribirAlumno', 'WWAlumnosxCarrera'),
  admin('/ecur', 'GenerateEstadoCurricular', 'WWCertificados'),
  admin('/conactas', 'ConsultarActas', 'WWActasExamen'),
  admin('/md-aud', 'MDAuditoria', 'WWAuditoria'),
  admin('/accur', 'ActualizarRegularidades', 'HistoriaAcademicaCursada'),
  admin('/acur/load/:id', 'CargarActaCursada', 'WWActasCursado'),
  admin('/aex/load/:id', 'CargarActaExamen', 'WWActasExamen'),
  admin('/acur/watch/:id', 'VerActaCursada', 'WWActasCursado'),
  admin('/aex/watch/:id', 'VerActaExamen', 'WWActasExamen'),
  alumno('/md-ica', 'MDInscripcionCursadaAlumno'),
  alumno('/add-ica', 'AddInscripcionCursadaAlumnos'),
  alumno('/update-ica/:id/:details', 'UpdateInscripcionCursadaAlumno'),
];

export const publicPaths = routeSecurityRegistry
  .filter((r) => r.access === 'Public')
  .map((r) => r.path);
